import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import { FadeIn } from './FadeIn';
const faqs = [{
  q: '¿Tengo que comprar equipos caros?',
  a: 'No, solo necesitas ajustes simples en tu termostato y luces que ya tienes en casa.'
}, {
  q: '¿Funciona si tomo medicación para la menopausia?',
  a: 'Sí, el protocolo es un excelente complemento natural para regular el ritmo circadiano.'
}, {
  q: '¿Es difícil de seguir?',
  a: 'Para nada. Son ajustes pequeños en tu rutina que se sienten como un mimo personal.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-14 px-4 bg-navy-800/30" data-id="element-15">
      <div className="max-w-3xl mx-auto" data-id="element-16">
        <FadeIn data-id="element-17">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-center text-warmWhite-100 mb-8" data-id="element-18">
            Preguntas Frecuentes
          </h2>
        </FadeIn>

        <div className="space-y-3" data-id="element-19">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <FadeIn key={index} delay={index * 0.1} data-id="element-20">
                <div className="glass-card rounded-xl overflow-hidden" data-id="element-21">
                  <button onClick={() => setOpenIndex(isOpen ? null : index)} className="w-full px-5 py-4 flex items-center justify-between text-left hover:bg-white/5 transition-colors" data-id="element-22">
                    <span className="text-base font-heading font-bold text-warmWhite-100 pr-6" data-id="element-23">
                      {faq.q}
                    </span>
                    <motion.div animate={{
                  rotate: isOpen ? 180 : 0
                }} transition={{
                  duration: 0.3,
                  ease: 'easeInOut'
                }} className="shrink-0" data-id="element-24">
                      <ChevronDown className="w-5 h-5 text-gold-400" data-id="element-25" />
                    </motion.div>
                  </button>

                  <AnimatePresence initial={false} data-id="element-26">
                    {isOpen && <motion.div initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.3,
                  ease: 'easeInOut'
                }} data-id="element-27">
                        <div className="px-5 pb-4 text-warmWhite-200 leading-relaxed border-t border-white/5 pt-3" data-id="element-28">
                          {faq.a}
                        </div>
                      </motion.div>}
                  </AnimatePresence>
                </div>
              </FadeIn>;
        })}
        </div>
      </div>
    </section>;
}